import { FormStateType } from "../../../../types";
import { CLAIM_DETAILS_CONSTANTS } from "../../../constants";

export const formFieldsState: FormStateType = {
  [CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_CLAIM]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_DETAILS_GROUP]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [CLAIM_DETAILS_CONSTANTS.QUANTITY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.HANDLING_UNIT_IDENTIFIER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.WEIGHT]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.WEIGHT_UNIT_TYPE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.DESCRIPTION_OF_CARGO_OR_PROPERTY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.MATERIAL_PART_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.AMAZON_PART_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.PURCHASE_ORDER_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.WAREHOUSE_MANAGEMENT_SYSTEM_ORDER_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.AMAZON_STANDARD_IDENTIFICATION_NUMBER]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_DETAILS_CONSTANTS.MULTIPLE_ITEM_CLAIM_ATTACHMENT]: {
    value: [],
    errors: [],
    hidden: true,
  },
};
